import { CappingData } from './cappingData';
import { TmsData } from './tmsData';

export class TrackingData {
    public featureName?: string;
    public functionality?: string;
    public tmsTracking?: TmsData;
    public cappingTracking?: CappingData;

    public constructor(init?: Partial<TrackingData>) {
        Object.assign(this, init);
    }
}
